import { createContext, useContext, useState } from 'react';

const Context = createContext();

export const useFormContext = () => useContext(Context);

export const FormContextProvider = Context.Provider;

export function useForm({ config, initialState, onChange }) {
    const [state, setState] = useState({
        values: initialState,
        errors: {},
    });

    const onChangeKeyValue = (key, value) => {
        const conf = config[key];
        let parsed = value;

        if (conf) {
            if (value !== null) {
                if (conf.type === 'number') {
                    parsed = parseFloat(value);
                }
            }

            if (conf.onChange) {
                // eslint-disable-next-line no-use-before-define
                conf.onChange(parsed, form);
            }
        }

        setState((st) => {
            const validationResult = conf && conf.validate
                ? conf.validate(parsed, st.values)
                : null;

            const { clearErrorFor } = validationResult && typeof validationResult === 'object' ? validationResult : {};
            const newError = typeof validationResult === 'string' ? validationResult : undefined;

            const newValues = {
                ...st.values,
                [key]: parsed,
            };

            onChange && onChange(newValues);

            return {
                ...st,
                values: newValues,
                errors: {
                    ...st.errors,
                    [clearErrorFor || key]: undefined,
                    [key]: newError,
                },
            };
        });
    };

    const handleChange = (e) => {
        if (typeof e === 'object' && 'field' in e && 'value' in e) {
            onChangeKeyValue(e.field, e.value);
        } else if (Array.isArray(e)) {
            e.forEach((change) => {
                if (change) {
                    onChangeKeyValue(change.field, change.value);
                }
            });
        } else {
            const { value } = e.target;
            onChangeKeyValue(e.target.name, value === '' ? null : value);
        }
    };

    const form = {
        config,
        values: state.values,
        errors: state.errors,
        setState,
        onChange: handleChange,
    };

    return form;
}



// WEBPACK FOOTER //
// ./app/components/common/Form/form.jsx